/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  internetConnectionStatus: false,
  data: {},
  subscribedApps: {},
  avatarColorSet: 'FFAD08,EDD75A,73B06F,0C8F8F,405059',
  avatarNameGenerator: (f, l) => { 
    if(f) {
      return `${f.charAt(0)}%20${l.charAt(0)}`; 
    } else {
      return `S%20G`;
    }
  },
  galaAvatar: '',
  galaAbilities: []
}